import { constants as config } from '@config';
import ScrollableMixin from '../mixins/scrollable';
import ImagesFactory from '../../../../factory/images';

module.exports = Backbone.mixin(Backbone.mixin(Backbone.View.extend({
  from: 0,
  limit: 10,
  apiCall: '',
  callbackName: 'callbackImages',
  template: require('./template-content.hbs'),

  initialize: function () {
    _.bindAll(this, 'masonryReload', 'render', 'loadData', 'onMoreData', 'closeView');
    this.views = {};

    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;

    this.imagesFactory = ImagesFactory;
    this.scrollRefresh = _.debounce(_.bind(this.initScroll, this), 2000);

    this.render();

    _.delay(_.bind(function () {
      this.initScroll();
      this.initDataLoading();
    }, this), 1000);
  },

  initDataLoading: function () {
    const $thumbnailWrapper = this.$el.find('.thumbnail-wrapper');
    this.end && this.end();
    this.tool.initScrollDetect($thumbnailWrapper, this.loadData);
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    INKIVE.Helpers.api(this.apiCall, 'GET', this.getParams(), this.onMoreData);
  },

  onMoreData: function (result) {
    const hasResults = result && result.data && result.data.length > 0;
    const activeTab = INKIVE.Helpers.getActiveTab();
    const isAdminTab = activeTab === 'admin';
    const isTextTab = activeTab === 'text';
    const isTextBannersActive = data => data.active === '1' && (isTextTab || data.isText === '0');
    const isTextActiveItem = data => isTextTab && data.type === 'text' && data.text;

    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));

    if (hasResults) {
      const filteredData = result.data.filter(data => isAdminTab || isTextBannersActive(data) || isTextActiveItem(data));

      this.appendThumbnails(filteredData);
      this.repeat();
    } else this.end();

    this.scrollRefresh();
  },

  appendThumbnails: function (data) {
    const callback = _.bind(this.tool[this.callbackName], this.tool);

    this.tool.addThumbItem(this.$el, this.extractData(data), callback);
    this.masonryReload();
    this.canvas.showOverlayElements();
  },

  render: function () {
    this.$el.html(this.template());
    this.$el.find('.antiscroll-inner').addThumb();
  },

  remove: function () {
    this.undelegateEvents();
    this.$el.removeData().unbind();
    Backbone.View.prototype.remove.call(this);
  },

  getParams: function () {
    return { };
  },

  extractData: function (data) {
    return data;
  },

  openNewView: function (viewName, View, data) {
    const $view = $('<div></div>')
      .addClass('image-list out right');

    $view.insertAfter(this.$el);

    this.$el.addClass('out left');
    this.views[viewName] = new View(_.extend({ el: $view }, data));
    this.trigger('open_new_view', data);

    _.defer(function () {
      $view.removeClass('out right');
    });
  },

  closeView: function () {
    this.$el.removeClass('out left');
    _.each(this.views, function (view, key) {
      if (key === 'uploadThumbnail') return;
      view.$el.addClass('out right');
      _.delay(function () {
        view.remove();
      }, 1000);
    });

    this.views = {};
    return true;
  },

  getScrollHeight: function ($target) {
    const containerHeight = $target.closest('.tool-content').height();
    const buttonHeight = $target.siblings('.btn.btn-accordion').height();

    return containerHeight - buttonHeight;
  },

  masonryReload: function () {
    this.$el.find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);

    this.initScroll();
    this.scrollRefresh();
  }
}), Backbone.Events), ScrollableMixin);
